module.exports = __webpack_public_path__ + "static/media/tpn-user-feedback.fdf9d472.jpg";